import { render, staticRenderFns } from "./LineItems.vue?vue&type=template&id=04381e43"
import script from "./LineItems.vue?vue&type=script&lang=js"
export * from "./LineItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports